import { render, staticRenderFns } from "./SuccessDialog.vue?vue&type=template&id=08d3b79e&"
import script from "./SuccessDialog.vue?vue&type=script&lang=js&"
export * from "./SuccessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports